import { MenuItem, TextField } from "@mui/material";
import { useMemo } from "react";
import { useGetProductsQuery } from "src/api/services/productsApi";
import { FilterProps } from "src/api/types";

const ProductFilter = ({ filter, onChange, placeholder }: FilterProps) => {
  const { data } = useGetProductsQuery(undefined, {
    selectFromResult: ({ data }) => {
      return { data: data?.data ?? [] };
    },
  });

  const products = useMemo(() => {
    return data.filter((p) => !p.name.includes("OT"));
  }, [data]);

  return (
    <TextField
      label={placeholder}
      select
      sx={{ width: 180 }}
      size="small"
      value={filter}
      onChange={onChange}
    >
      <MenuItem value={""}>{"None"}</MenuItem>
      {products.map((product) => (
        <MenuItem key={product.id} value={product.name}>
          {product.name}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default ProductFilter;
